import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Button, Paper } from "@mui/material";

/**
 * EmptyState component for displaying when no data is available
 * @param {Object} props - Component props
 * @returns {JSX.Element} EmptyState component
 */
const EmptyState = ({
  icon,
  title,
  description,
  actionText,
  onAction,
  paperProps = {},
  sx = {},
}) => {
  return (
    <Paper
      sx={{
        p: 4,
        textAlign: "center",
        ...sx,
      }}
      {...paperProps}
    >
      {icon && <Box sx={{ mb: 2, color: "text.secondary" }}>{icon}</Box>}

      {title && (
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
      )}

      {description && (
        <Typography variant="body1" color="text.secondary" paragraph>
          {description}
        </Typography>
      )}

      {actionText && onAction && (
        <Button
          variant="contained"
          color="primary"
          onClick={onAction}
          sx={{ mt: 2 }}
        >
          {actionText}
        </Button>
      )}
    </Paper>
  );
};

EmptyState.propTypes = {
  /** Icon element to display */
  icon: PropTypes.node,
  /** Title text */
  title: PropTypes.string,
  /** Description text */
  description: PropTypes.string,
  /** Text for the action button */
  actionText: PropTypes.string,
  /** Function to call when action button is clicked */
  onAction: PropTypes.func,
  /** Additional props to pass to the Paper component */
  paperProps: PropTypes.object,
  /** Additional styles to apply to the component */
  sx: PropTypes.object,
};

export default EmptyState;
